import { Injectable } from '@angular/core';
import { NetworkService } from "../../common/network.service";


@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  constructor(private _networkService: NetworkService) { }




  NotificationList() {
    return this._networkService.get("api/admins/notifications", null, null, "bearer")
  }
  SendNotification(body: any) {
    return this._networkService.post("api/admins/notifications", body, null, "bearer")
  }
  getUsersDropDownList(query:any) {

    return this._networkService.get("api/users/userList?"+query, null, null, "bearer");
  }

}
